import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { AppState } from "store/store"
import { useSelector } from "react-redux"
import Toolbar from "@mui/material/Toolbar"
import IconButton from "@mui/material/IconButton"
import { Button } from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import { APP_URL } from "Const"
import { buildUrlWithParams } from "utils/BuildUrlWithParams"
import styles from "./CommonHeader.module.scss"

export interface CommonHeaderProps {
  full?: boolean
}
/**
 * 共通ヘッダー
 * @param {string} full - 全画面表示時はアイコンボタンのみ(削除予定)
 */
const CommonHeader = ({ full = false }: CommonHeaderProps) => {
  const navigate = useNavigate()
  const couponCode = useSelector((state: AppState) => state.couponCode.couponCode)
  const cameraOff = useSelector((state: AppState) => state.cameraOff.cameraOff)
  const goHome = () => {
    navigate(buildUrlWithParams(APP_URL.TOP, couponCode, cameraOff))
  }
  return (
    <>
      {full ? (
        <IconButton edge="start" color="inherit" aria-label="menu" className={styles.full}>
          <MenuIcon
            onClick={() => {
              goHome()
            }}
            className={styles.icon}
          />
        </IconButton>
      ) : (
        <Toolbar variant="dense" className={styles.toolBar}>
          <Button
            onClick={() => {
              goHome()
            }}
            className={styles.iconButton}
            color="inherit"
            aria-label="menu"
          >
            <span>
              <img alt="logo" src="./header-logo.svg" />
            </span>
          </Button>
        </Toolbar>
      )}
    </>
  )
}
export default CommonHeader
